// The admin console's entry: fonts (self-hosted, D74; brand v2, D121), styles, the query client and the router.
import '@fontsource-variable/funnel-display'
import '@fontsource-variable/funnel-sans'
import '@fontsource-variable/martian-mono/standard.css'
import './styles.css'
import { applyRail, readRail, StripFit } from '@apsio/ui'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { isApiError } from './api/client'
import { startErrorTracking } from './lib/errors'
import { makeRouter } from './router'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Errors with a status are answers, not glitches: no retry.
      retry: (count, error) => !isApiError(error) && count < 2,
      refetchOnWindowFocus: false,
    },
  },
})
const router = makeRouter(queryClient)
// Apsio's own error tracking (plan step 2.4; D59): nothing on a build without a key.
void startErrorTracking()
// The folded sidebar, as last chosen on this device, before the first paint (brand v2).
applyRail(readRail())

const root = document.getElementById('root')
if (root)
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        {/* Every 4-cell strip four across or two by two by its own width (APS-412). */}
        <StripFit.Provider value>
          <RouterProvider router={router} />
        </StripFit.Provider>
      </QueryClientProvider>
    </StrictMode>,
  )
